import { render, staticRenderFns } from "./AOI.vue?vue&type=template&id=0aa0e65d&scoped=true&"
import script from "./AOI.vue?vue&type=script&lang=js&"
export * from "./AOI.vue?vue&type=script&lang=js&"
import style0 from "./AOI.vue?vue&type=style&index=0&id=0aa0e65d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa0e65d",
  null
  
)

export default component.exports